// [MELHORIA] Novo componente - Histórico de Redistribuições
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import CustomizedSnackbars from '../../components/material-snackbars';
import { withRouter } from 'react-router-dom';
import Api from '../../services/api';
import MyMaterialTable from '../../components/table/index-report';
import { AbilityContext } from '../../config/ability-context';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import * as componentActions from '../../redux/actions/calledstatuses';
import { PapiroConsole } from '../../utils/papiroConsole';

class CalledRedistributionHistory extends Component {

    constructor(props) {
        super(props);

        const { calleds } = this.props;
        const { id } = this.props.match.params;

        this.urlId = id;

        this.state = {
            calledId: id ? id : calleds.called.id,
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            resultList: [],
        };

        this.closeNotification = this.closeNotification.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.state === 'reload') {
            this.componentDidMount();
        }
    }

    async componentDidMount() {
        await this.getItens();
    }

    async getItens() {
        this.setState({ loading: true });

        await Api.get(`/called-redistribution/history/${this.state.calledId}`)
            .then(result => {
                if (result.data.success) {
                    PapiroConsole.log(result.data.data);
                    PapiroConsole.log('called-redistribution-history');

                    const formattedList = result.data.data.map(item => ({
                        SourceUserName: item.sourceusername ? item.sourceusername : '',
                        TargetUserName: item.targetusername ? item.targetusername : '',
                        Reason: item.reason ? item.reason : '',
                        DateCreated: moment(item.createdat).format('DD/MM/YYYY HH:mm:ss'),
                        CreatedUserName: item.createdusername ? item.createdusername : '',
                    }));

                    this.setState({ loading: false, resultList: formattedList });
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0]
                            ? result.data.response.data.errors[0]
                            : intl.formatMessage({ id: 'process.error' }),
                    });
                    Api.kickoff(result);
                }
            })
            .catch(err => {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0]
                        ? err.response.data.errors[0]
                        : intl.formatMessage({ id: 'process.error' }),
                });
                Api.kickoff(err);
            });
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    render() {
        const intl = this.props.intl;

        return (
            <>
                <MyMaterialTable
                    title="Histórico de Redistribuições"
                    columns={[
                        { title: 'Técnico de Origem', field: 'SourceUserName' },
                        { title: 'Técnico de Destino', field: 'TargetUserName' },
                        { title: 'Motivo da Redistribuição', field: 'Reason' },
                        { title: intl.formatMessage({ id: 'date' }), field: 'DateCreated' },
                        { title: intl.formatMessage({ id: 'user' }), field: 'CreatedUserName' },
                    ]}
                    data={this.state.resultList}
                />

                <CustomizedSnackbars
                    variant={this.state.notificationVariant}
                    message={this.state.notificationMessage}
                    isOpen={this.state.openNotification}
                    toClose={this.closeNotification}
                />

                {this.state.loading && (
                    <Overlay>
                        <CircularProgress color='secondary' />
                    </Overlay>
                )}
            </>
        );
    }
}

CalledRedistributionHistory.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    userSession: state.userSession,
    calleds: state.calleds,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(CalledRedistributionHistory))));

CalledRedistributionHistory.contextType = AbilityContext;